console.log('js/toast.js -> v0.1.0');

const toast = (() => {
	const get = (idSelector = '#toast-inner') => $(idSelector)

	const clear = () => get().empty()

	const fade = element => $(element).fadeOut()

	const message = (type, texts, options, then, thenParams) => {
		if (!Array.isArray(texts)) {
			texts = [ texts ]
		}

		const toast = get()
		texts.map(text => {
			const child = []

			if (options && options.icon) {
				const icon = {
					tag: 'i',
					class: `toast-icon ebs-icon ${options.icon}`,
				}
				child.push(icon)
			}

			if (text) {
				const textArea = {
					tag: 'span',
					class: 'toast-text',
					child: text.replace(/(?:\r\n|\r|\n)/g, '<br>')
				}
				child.push(textArea)
			}

			if (options && options.buttonText && options.buttonURL) {
				const button = 	{
					tag: 'a',
					class: 'bttn -small -outline',
					href: options.buttonURL,
					data: { toggle: options.dataToggle },
					child: {
						tag: 'span',
						child: options.buttonText
					}
				}
				child.push(button)
			}

			const alertElement = document.createElement('div');
			alertElement.setAttribute('class', `alert alert-${type} toast-alert toast-alert-dismissible`);
			alertElement.setAttribute('role', 'alert');

			let children = [];

			child.forEach(item => {
				let container = document.createElement(item.tag);
				container.setAttribute('class', item.class);

				if(item.hasOwnProperty('data')) {
					container.setAttribute('data-' + Object.keys(item.data)[0], item.data[Object.keys(item.data)[0]]);
				}
		
				if(item.hasOwnProperty('href')) {
					container.setAttribute('href', item.href);
				}
		
				if (item.hasOwnProperty('child')) {
					if(item.child.hasOwnProperty('child')) {
						var innerChild = document.createElement(item.child.tag);
						var innerChildText = document.createTextNode(item.child.child);
						innerChild.appendChild(innerChildText);
						container.appendChild(innerChild);
					}
					else {
						var childText = document.createTextNode(item.child);
						container.appendChild(childText);
					}
				}

				children.push(container);
			});

			alertElement.append(...children);
			toast.append(alertElement)

			if (then) {
				window.setTimeout(() => then(alertElement, thenParams), options.delay || 2500)
			}
		})


	}

	const success = (text, options, then, thenParams) =>
		message('success', text, options, then, thenParams)

	const info = (text, options, then, thenParams) =>
		message('info', text, options, then, thenParams)

	const error = (text, options, then, thenParams) =>
		message('danger', text, options, then, thenParams)

	const favorite = (text, options, then, thenParams) => {
		const overrides = {
			icon: 'ebs-icon-heart-stroked'
		}
		const favoriteOptions = Object.assign({}, options, overrides)

		info(text, favoriteOptions, then, thenParams)
	}

	return {
		get,
		clear,
		message,
		success,
		info,
		error,
		favorite,
		fade
	}
})();
